import React from 'react';
import { Snackbar } from '../components/snackbar';
import { FormattedMessage } from 'react-intl';
import { call } from './../utilities/http';
import Position from './../models/position';
import { history } from './../configuration/store';
import { LOADING, COMPLETE, POSITIONS_GET_OK, POSITIONS_GET_SINGLE_OK, POSITIONS_SAVE_OK, POSITIONS_JOB_INVITATION_SENT_OK, SAVING } from './types';

const defaultState = {
    list: undefined,
    draft: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case POSITIONS_GET_OK:
            return { ...state, list: action.data };

        case POSITIONS_GET_SINGLE_OK:
        case POSITIONS_SAVE_OK:
            let position = {};
            if (action.data.id !== undefined) {
                position[action.data.id] = action.data;
            } else {
                position.new = action.data;
            }
            return { ...state, ...position };

        case POSITIONS_JOB_INVITATION_SENT_OK:
            return state;

        default:
            return state;
    }
}

export function getPositions(role, extended = true, onSuccess = undefined, onError = undefined) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/position?ref_type=${role.type}&ref_id=${role.id}&status=active&extended=${extended}` })
            .then(response => {
                dispatch({ type: POSITIONS_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                if (onSuccess) {
                    onSuccess(response);
                }
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.companyPositions'} defaultMessage={'Unable to retrieve company positions.'} />);
                dispatch({ type: COMPLETE });
                if (onError) {
                    onError();
                }
            });
    };
}

export function getPosition(id, extended = true, onSuccess = () => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/position/${id}?extended=${extended}` })
            .then(response => {
                if (response.rate === 0) {
                    response.rate = undefined;
                }
                dispatch({ type: POSITIONS_GET_SINGLE_OK, data: response });
                onSuccess(response);
                dispatch({ type: COMPLETE });
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.companyPosition'} defaultMessage={'Unable to retrieve company position.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

export function savePosition(position, onSuccess = () => null, onError = error => Snackbar.error(error)) {
    const action = position.id ? updatePosition : createPosition;
    return action(position, onSuccess, onError);
}

/**
 * TODO: Remove approval call
 * @param {Position} position
 */
function createPosition(position, onSuccess, onError) {
    const positionData = new Position(position);
    positionData.id = position.id;
    return async function(dispatch) {
        // Once location is created and updated position with location id, create position.
        dispatch({ type: SAVING });
        call({ path: `/position`, method: 'POST', body: positionData })
            .then(positionResponse => {
                dispatch({ type: POSITIONS_SAVE_OK, data: { ...position, id: positionResponse.id } });
                dispatch({ type: COMPLETE });
                history.push(`/position/${positionResponse.id}`);
                onSuccess(positionResponse);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

function updatePosition(position, onSuccess = () => null, onError = () => null) {
    const positionData = new Position(position);
    positionData.id = position.id;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/position/${positionData.id}`, method: 'PUT', body: positionData })
            .then(() => {
                dispatch({ type: POSITIONS_SAVE_OK, data: position });
                dispatch({ type: COMPLETE });
                onSuccess(position);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
                onError(error);
            });
    };
}

export function approvePosition(id) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/position/${id}/action/approve`, method: 'POST' })
            .then(response => {
                dispatch({ type: COMPLETE });
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
            });
    };
}

export function sendJobInvite(values, onSuccess = response => null, onError = error => Snackbar.error(error)) {
    const data = {
        position_id: values.id,
        start_date: values.start_date,
        end_date: values.end_date,
        rate: values.rate,
        title: values.title,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email.toLowerCase(),
        phone: values.phoneNumber,
        projects: values.projects
    };

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job_invite`, method: 'POST', body: data })
            .then(response => {
                dispatch({ type: POSITIONS_JOB_INVITATION_SENT_OK });
                dispatch({ type: COMPLETE });
                onSuccess(response);
                Snackbar.success(
                    <FormattedMessage id={'inviteWorker.success'} values={{ ...values }} defaultMessage={'Invitation sent to {first_name} {last_name}.'} />
                );
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/positions.jsx